import { Component, Input } from '@angular/core';
import { FormGroup, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'ls-input-text',
  templateUrl: './ls-input-text.component.html'
})
export class LsInputTextComponent implements ControlValueAccessor {
  @Input()
  public key: string;
  @Input()
  public value: boolean;
  @Input()
  public description: string;
  @Input()
  public title: string;
  @Input()
  public required: boolean;
  @Input()
  public disabled: boolean;
  @Input()
  public visible: boolean;
  @Input()
  public form: FormGroup;
  @Input()
  public tooltip: String;

  public writeValue(value: any): void {
    this.value = value;
  }

  public registerOnChange(): void {
    return;
  }

  public registerOnTouched(): void {
    return;
  }

  public get isValid(): boolean {
    return this.form.controls[this.key].valid;
  }

  public get errorMessage(): string {
    const errors: any = this.form.controls[this.key].errors;
    if (errors.required) {
      return this.title + ' is a required field';
    } else if (errors.minlength) {
      return (
        this.title +
        ' must be ' +
        errors.minlength['requiredLength'] +
        ' characters long'
      );
    } else if (errors.maxlength) {
      return (
        this.title + ' must be shorter than' + errors.max['requiredLength']
      );
    }
  }
}
